import { createApp } from 'vue'
import router from './router/index.js'
import App from './App.vue'

// Thứ tự import CSS theo UI-MIGRATION-GUIDE (Bước 0.5): tokens -> fonts -> main.
import './assets/styles/tokens.css'
import './assets/styles/fonts.css'
import './assets/main.css'

createApp(App).use(router).mount('#app')
